import { render, staticRenderFns } from "./FaUserPrerendered.vue?vue&type=template&id=5acaca84&"
import script from "./FaUserPrerendered.vue?vue&type=script&lang=js&"
export * from "./FaUserPrerendered.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports